<era-location-select-ui [locations]="locations$ | async"
                        [location]="location$ | async"
                        (locationChange)="selected($event)"
                        [isEnabled]="isEnabled"></era-location-select-ui>